(function () {
  'use strict';

  var SESSION_KEY = 'askAvantreeSessionId';
  var SESSION_CONTEXT_KEY = 'askAvantreeSessionContextV1';
  var VISITOR_KEY = 'aiConversationVisitorId';
  var PRODUCT_HANDOFF_KEY = 'askAvantreeProductHandoffV1';
  var PRODUCT_HANDOFF_TTL = 30 * 60 * 1000;

  var root = document.querySelector('[data-ask-avantree-root]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  root.hidden = false;

  document.querySelectorAll('[data-ask-avantree-entry]').forEach(function (entry) {
    entry.hidden = false;
  });

  var drawer = root.querySelector('[data-ask-drawer]');
  var conversation = root.querySelector('[data-ask-conversation]');
  var messages = root.querySelector('[data-ask-messages]');
  var form = root.querySelector('[data-ask-form]');
  var input = root.querySelector('[data-ask-input]');
  var send = root.querySelector('[data-ask-send]');
  var mic = root.querySelector('[data-ask-mic]');
  var voiceStatus = root.querySelector('[data-ask-voice-status]');
  var productName = root.querySelector('[data-ask-product-name]');
  var productPicker = root.querySelector('[data-ask-product-picker]');
  var productSelect = root.querySelector('[data-ask-product-select]');
  var languageSelect = root.querySelector('[data-ask-language]');
  var backButton = root.querySelector('[data-ask-back]');
  var floatingButton = root.querySelector('.ask-avantree__floating[data-ask-open]');

  var data = null;
  var translations = null;
  var currentLocale = 'en-US';
  var currentProduct = null;
  var currentIntent = null;
  var currentStepId = null;
  var stepHistory = [];
  var conversationLog = [];
  var conversationState = null;
  var handledResponseEventIds = {};
  var stepsTaken = [];
  var knowledgeFallbackHistory = {};
  var lastFocused = null;
  var pendingIntent = null;
  var awaitingProductModel = false;
  var pendingProductQuestion = '';
  var pendingProductTurnEventIds = null;
  var pendingCanonicalQuestion = '';
  var requestInFlight = false;
  var selectedProductOverridesPageContext = false;
  var defaultUi = {};
  var floatingDrag = { active: false, moved: false, pointerId: null, startX: 0, startY: 0, left: 0, top: 0, width: 0, height: 0 };
  var suppressFloatingClick = false;

  document.querySelectorAll('[data-ask-i18n]').forEach(function (element) {
    var key = element.dataset.askI18n;
    if (key && !defaultUi[key]) defaultUi[key] = element.textContent.trim();
  });

  [
    ['[data-ask-i18n-aria-label]', 'askI18nAriaLabel', 'aria-label'],
    ['[data-ask-i18n-placeholder]', 'askI18nPlaceholder', 'placeholder'],
    ['[data-ask-i18n-title]', 'askI18nTitle', 'title']
  ].forEach(function (definition) {
    document.querySelectorAll(definition[0]).forEach(function (element) {
      var key = element.dataset[definition[1]];
      if (key && !defaultUi[key]) defaultUi[key] = element.getAttribute(definition[2]) || '';
    });
  });

  var datasetUiKeys = {
    listening: 'listeningText',
    voice_unavailable: 'voiceUnavailableText',
    voice_error: 'voiceErrorText',
    loading: 'loadingText',
    load_error: 'loadErrorText',
    source: 'sourceText',
    resolved_title: 'resolvedTitle',
    resolved_copy: 'resolvedCopy',
    helpful_question: 'helpfulQuestion',
    escalation_copy: 'escalationCopy',
    contact_support: 'contactSupport',
    unknown_question: 'unknownQuestion'
  };

  Object.keys(datasetUiKeys).forEach(function (key) {
    if (!defaultUi[key]) defaultUi[key] = root.dataset[datasetUiKeys[key]] || '';
  });

  var staticUiFallback = {
    close: 'Close',
    helpful_yes: 'Helpful',
    helpful_no: 'Not helpful',
    mail_subject: 'Ask Avantree help',
    mail_product: 'Product',
    mail_sku: 'SKU',
    mail_problem: 'Problem',
    mail_page: 'Page',
    mail_steps: 'Steps already tried:',
    mail_conversation: 'Conversation summary:',
    mail_customer: 'Customer:',
    mail_avantree: 'Avantree:',
    mail_final_details: 'Please add any final details here:',
    mail_unclassified: 'Not classified',
    ask_product_model: 'Which Avantree product are you using? Please type the product name or model number shown on the product or label.',
    searching_products: 'Searching Avantree products…',
    product_not_found: 'I could not find that product yet. Please type the exact product name or model number from the product or label.',
    product_search_error: 'I could not search the product catalog right now. Please check the product name or model number and try again.',
    opening_product: 'I found {{ product }}. I’ll open its product page so we can continue there.',
    product_confirmed: 'Great — I’ll use {{ product }}. What would you like help with?',
    followup_title: 'Still need help? We’ll keep working on it.',
    followup_copy: 'Thank you for your patience. Leave your email and our support team will send an improved answer within one business day. Your feedback will also help Ask Avantree answer better next time.',
    followup_email: 'Email address',
    followup_consent: 'I agree that Avantree may use this email to send this support follow-up.',
    followup_submit: 'Email me the improved answer',
    followup_sending: 'Creating your follow-up…',
    followup_success: 'Thank you. Our support team will email you an improved answer within one business day.',
    handoff_completed: 'Your request has been sent to Avantree Support. Support reference: ',
    followup_error: 'We could not create the follow-up. Please check the email and try again.',
    escalation_email_title: 'Continue with Avantree Support',
    escalation_email_copy: 'Ask Avantree is not yet connected to live support. Please leave your email address and I’ll send this conversation to Avantree Support.',
    escalation_email_submit: 'Send conversation to Support',
    escalation_email_sending: 'Sending your conversation…',
    escalation_email_decline: 'No thanks',
    escalation_email_failure: 'Support could not be notified automatically. Please email support@avantrae.com directly.'
  };

  function createSessionId() {
    return window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : 'aa-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function getPageContextKey() {
    return [
      normalize(root.dataset.pageContextType),
      normalize(root.dataset.productHandle || root.dataset.pageContextTitle || window.location.pathname)
    ].join(':');
  }

  function isIntentionalProductHandoff() {
    try {
      var handoff = readProductHandoff();
      return new URL(window.location.href).searchParams.get('ask_avantree_continue') === '1'
        && handoff
        && normalize(handoff.targetHandle) === normalize(root.dataset.productHandle);
    } catch (error) {
      return false;
    }
  }

  function rememberSessionContext() {
    try { window.sessionStorage.setItem(SESSION_CONTEXT_KEY, getPageContextKey()); } catch (error) {}
  }

  function getSessionId() {
    try {
      var stored = window.sessionStorage.getItem(SESSION_KEY);
      var storedContext = window.sessionStorage.getItem(SESSION_CONTEXT_KEY);
      var pageContext = getPageContextKey();
      if (stored && (storedContext === pageContext || isIntentionalProductHandoff())) {
        window.sessionStorage.setItem(SESSION_CONTEXT_KEY, pageContext);
        return stored;
      }
      var created = createSessionId();
      window.sessionStorage.setItem(SESSION_KEY, created);
      window.sessionStorage.setItem(SESSION_CONTEXT_KEY, pageContext);
      return created;
    } catch (error) {
      return createSessionId();
    }
  }

  function renewSessionId() {
    sessionId = createSessionId();
    try {
      window.sessionStorage.setItem(SESSION_KEY, sessionId);
      rememberSessionContext();
    } catch (error) {
      // The in-memory session still separates the new conversation.
    }
  }

  function getVisitorId() {
    try {
      var handoff = new URL(window.location.href).searchParams.get('ai_journey_id');
      var stored = handoff || window.localStorage.getItem(VISITOR_KEY);
      if (stored) {
        window.localStorage.setItem(VISITOR_KEY, stored);
        return stored;
      }
      var created = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : 'av-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      window.localStorage.setItem(VISITOR_KEY, created);
      return created;
    } catch (error) {
      return sessionId;
    }
  }

  var sessionId = getSessionId();
  var visitorId = getVisitorId();

  function activeProductForTelemetry() {
    if (root.dataset.productHandle) {
      return { handle: root.dataset.productHandle, title: root.dataset.productTitle || '', sku: root.dataset.productSku || '' };
    }
    if (currentProduct && data && data.general && normalize(currentProduct.handle) !== normalize(data.general.handle)) {
      return { handle: currentProduct.handle, title: currentProduct.title, sku: currentProduct.sku || '' };
    }
    return { handle: '', title: '', sku: '' };
  }

  function analyticsFields(extra) {
    var telemetryProduct = activeProductForTelemetry();
    var base = {
      product_handle: telemetryProduct.handle,
      sku: telemetryProduct.sku,
      intent: currentIntent || '',
      problem_category: currentIntent && currentProduct && currentProduct.intents[currentIntent]
        ? currentProduct.intents[currentIntent].category
        : '',
      steps_taken: stepsTaken.length,
      session_id: sessionId,
      locale: currentLocale,
      page_url: root.dataset.pageUrl || window.location.href.split('?')[0],
      timestamp: new Date().toISOString()
    };

    Object.keys(extra || {}).forEach(function (key) { base[key] = extra[key]; });
    return base;
  }

  function track(eventName, extra) {
    var fields = analyticsFields(extra);
    root.dataset.lastEvent = eventName;
    if (fields.resolution) root.dataset.lastResolution = fields.resolution;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, fields));
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('event', eventName, fields);
    document.dispatchEvent(new CustomEvent('ask-avantree:analytics', {
      detail: { event: eventName, fields: fields }
    }));
    var portalEvent = {
      ask_avantree_opened: 'opened',
      ask_avantree_restarted: 'restarted',
      troubleshooting_resolved: 'resolved',
      support_escalated: 'escalated',
      helpful_yes: 'helpful',
      helpful_no: 'not_helpful'
    }[eventName];
    if (portalEvent) sendPortalEvent(portalEvent, { intent: fields.intent, resolution: fields.resolution || '' });
  }

  function eventId() {
    return window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : '018f47a0-' + Math.random().toString(16).slice(2, 6).padEnd(4, '0') + '-7abc-8def-' + Math.random().toString(16).slice(2, 14).padEnd(12, '0');
  }

  function sendPortalEvent(eventName, extra, existingEventId) {
    if (!root.dataset.logUrl) return;
    var telemetryProduct = activeProductForTelemetry();
    var payload = Object.assign({
      event_id: existingEventId || eventId(),
      event: eventName,
      session_id: sessionId,
      visitor_id: visitorId,
      event_time: new Date().toISOString(),
      page_path: window.location.pathname,
      page_title: root.dataset.pageContextTitle || document.title,
      locale: currentLocale,
      product_handle: telemetryProduct.handle,
      product_name: telemetryProduct.title
    }, extra || {});
    fetch(root.dataset.logUrl, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: 'omit'
    }).catch(function () {});
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getUiText(key) {
    var locale = translations && translations.locales ? translations.locales[currentLocale] : null;
    return locale && locale.ui && locale.ui[key]
      ? locale.ui[key]
      : defaultUi[key] || staticUiFallback[key] || '';
  }

  function normalizeLocale(value) {
    var locale = String(value || '').replace('_', '-').toLowerCase();
    if (locale === 'zh' || locale.indexOf('zh-cn') === 0 || locale.indexOf('zh-hans') === 0) return 'zh-CN';
    if (locale === 'fr' || locale.indexOf('fr-') === 0) return 'fr-FR';
    if (locale === 'de' || locale.indexOf('de-') === 0) return 'de-DE';
    return 'en-US';
  }

  function detectLocale() {
    try {
      var stored = window.sessionStorage.getItem('askAvantreeLocale');
      if (stored) return normalizeLocale(stored);
    } catch (error) {}

    var transcy = document.querySelector('.transcy-select-language-items [aria-selected="true"][data-code]');
    return normalizeLocale(transcy ? transcy.dataset.code : document.documentElement.lang);
  }

  function translateValue(value, stringMap) {
    if (typeof value === 'string') return stringMap[value] || value;
    if (Array.isArray(value)) return value.map(function (item) { return translateValue(item, stringMap); });
    if (!value || typeof value !== 'object') return value;
    return Object.keys(value).reduce(function (result, key) {
      result[key] = translateValue(value[key], stringMap);
      return result;
    }, {});
  }

  function localizeProduct(product) {
    var locale = translations && translations.locales ? translations.locales[currentLocale] : null;
    var productTranslations = locale && locale.products ? locale.products[product.id] : null;
    var defaultTranslations = locale && locale.products ? locale.products['product-defaults'] : null;
    var stringMap = Object.assign(
      {},
      defaultTranslations && defaultTranslations.strings ? defaultTranslations.strings : {},
      productTranslations && productTranslations.strings ? productTranslations.strings : {}
    );
    return Object.keys(stringMap).length
      ? translateValue(product, stringMap)
      : product;
  }

  function localeSupportedByProduct(product, locale) {
    if (locale === 'en-US') return true;
    var localeData = translations && translations.locales ? translations.locales[locale] : null;
    return Boolean(product && localeData && (localeData.ui || (localeData.products && localeData.products[product.id])));
  }

  function rawProductForHandle(handle) {
    if (!data) return null;
    var matched = data.products
      ? data.products.find(function (product) { return productMatches(product, handle); })
      : null;
    if (matched) return matched;

    var pageHandle = normalize(root.dataset.productHandle);
    if (pageHandle && pageHandle === normalize(handle) && data.productDefaults) {
      return data.productDefaults;
    }
    return data.general || null;
  }

  function applyUiTranslations() {
    document.querySelectorAll('[data-ask-i18n]').forEach(function (element) {
      var text = getUiText(element.dataset.askI18n);
      if (text) {
        element.textContent = text;
        if (element.hasAttribute('data-ask-question')) element.dataset.askQuestion = text;
      }
    });

    [
      ['[data-ask-i18n-aria-label]', 'askI18nAriaLabel', 'aria-label'],
      ['[data-ask-i18n-placeholder]', 'askI18nPlaceholder', 'placeholder'],
      ['[data-ask-i18n-title]', 'askI18nTitle', 'title']
    ].forEach(function (definition) {
      document.querySelectorAll(definition[0]).forEach(function (element) {
        var text = getUiText(element.dataset[definition[1]]);
        if (text) element.setAttribute(definition[2], text);
      });
    });

    Object.keys(datasetUiKeys).forEach(function (key) {
      var text = getUiText(key);
      if (!text) return;
      root.dataset[datasetUiKeys[key]] = text;
    });
    root.dataset.activeLocale = currentLocale;
  }

  function renderLanguageOptions() {
    if (!languageSelect || !translations || !translations.locales) return;
    var product = currentProduct || rawProductForHandle(root.dataset.productHandle);
    var availableLocales = Object.keys(translations.locales).filter(function (code) {
      return localeSupportedByProduct(product, code);
    });
    languageSelect.textContent = '';
    availableLocales.forEach(function (code) {
      var option = document.createElement('option');
      option.value = code;
      option.textContent = translations.locales[code].label;
      languageSelect.appendChild(option);
    });
    languageSelect.value = currentLocale;
    languageSelect.parentElement.hidden = availableLocales.length < 2;
  }

  function productMatches(product, handle) {
    var wanted = normalize(handle);
    if (!wanted) return false;
    return normalize(product.handle) === wanted || (product.aliases || []).some(function (alias) {
      return normalize(alias) === wanted;
    });
  }

  function normalizeProductPhrase(value) {
    return normalize(value)
      .replace(/[^a-z0-9\u4e00-\u9fff]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function detectProductFromQuestion(question) {
    if (!data) return null;
    var normalizedQuestion = normalizeProductPhrase(question);
    if (!normalizedQuestion) return null;
    var searchableQuestion = ' ' + normalizedQuestion + ' ';
    var matches = (data.products || []).map(function (product) {
      var terms = [product.title, product.handle, product.sku].concat(product.aliases || []);
      var score = terms.reduce(function (highestScore, term) {
        var normalizedTerm = normalizeProductPhrase(term);
        if (!normalizedTerm || searchableQuestion.indexOf(' ' + normalizedTerm + ' ') === -1) return highestScore;
        return Math.max(highestScore, normalizedTerm.length);
      }, 0);
      return { product: product, score: score };
    }).filter(function (match) {
      return match.score > 0;
    }).sort(function (first, second) {
      return second.score - first.score;
    });

    if (matches.length) return getProductContext(matches[0].product.handle);

    var knowledgeMatches = (data.products || []).map(function (product) {
      var score = (product.knowledgeIndex || []).filter(function (entry) {
        return Boolean(entry.directAnswer);
      }).reduce(function (highestScore, entry) {
        var entryScore = (entry.keywords || []).reduce(function (total, keyword) {
          var normalizedKeyword = normalize(keyword);
          return normalizedKeyword && normalize(question).indexOf(normalizedKeyword) !== -1
            ? total + Math.max(1, normalizedKeyword.length)
            : total;
        }, 0);
        return Math.max(highestScore, entryScore);
      }, 0);
      return { product: product, score: score };
    }).filter(function (match) {
      return match.score > 0;
    }).sort(function (first, second) {
      return second.score - first.score;
    });

    return knowledgeMatches.length ? getProductContext(knowledgeMatches[0].product.handle) : null;
  }

  function getProductContext(handle) {
    if (!data) return null;
    var configuredProduct = rawProductForHandle(handle);
    if (!configuredProduct) return null;
    var isPageProduct = Boolean(root.dataset.productHandle)
      && normalize(handle) === normalize(root.dataset.productHandle);
    var defaults = configuredProduct.id !== 'general' ? data.productDefaults : null;
    var product = defaults
      ? Object.assign({}, defaults, configuredProduct, {
          sources: Object.assign({}, defaults.sources || {}, configuredProduct.sources || {}),
          knowledgeFallbacks: Object.assign({}, defaults.knowledgeFallbacks || {}, configuredProduct.knowledgeFallbacks || {}),
          intents: Object.assign({}, defaults.intents || {}, configuredProduct.intents || {})
        })
      : configuredProduct;
    var productTitle = isPageProduct && root.dataset.productTitle
      ? root.dataset.productTitle.split('|')[0].trim()
      : product.title;
    var pageUrl = isPageProduct
      ? (root.dataset.pageUrl || window.location.href.split('?')[0])
      : (product.sources && product.sources.product ? product.sources.product.url : root.dataset.pageUrl);
    var sources = Object.assign({}, product.sources || {});

    if (isPageProduct) {
      sources.product = {
        label: 'Current product page',
        url: pageUrl
      };
      if (configuredProduct.id === 'product-defaults' || !configuredProduct.sources || !configuredProduct.sources.support) {
        sources.support = {
          label: 'Product FAQ and support search',
          url: 'https://support.avantrae.com/hc/en-us/search?query=' + encodeURIComponent(productTitle)
        };
      }
    }

    return localizeProduct(Object.assign({}, product, {
      title: productTitle,
      handle: isPageProduct ? root.dataset.productHandle : product.handle,
      sku: isPageProduct && root.dataset.productSku ? root.dataset.productSku : product.sku,
      pageUrl: pageUrl,
      sources: sources
    }));
  }

  function getTroubleshootingFlow(productHandle, intent) {
    var product = getProductContext(productHandle);
    if (!product || !product.intents) return null;
    return product.intents[intent] || null;
  }

  function searchProductKnowledge(query) {
    if (!currentProduct || !currentProduct.knowledgeIndex) return [];
    var normalizedQuery = normalize(query);
    return currentProduct.knowledgeIndex.map(function (entry) {
      var score = (entry.keywords || []).reduce(function (total, keyword) {
        var normalizedKeyword = normalize(keyword);
        return normalizedKeyword && normalizedQuery.indexOf(normalizedKeyword) !== -1
          ? total + Math.max(1, normalizedKeyword.length)
          : total;
      }, 0);
      return Object.assign({}, entry, {
        score: score,
        sourceReference: currentProduct.sources && currentProduct.sources[entry.source]
      });
    }).filter(function (entry) {
      return entry.score > 0 && entry.sourceReference;
    }).sort(function (first, second) {
      return second.score - first.score;
    });
  }

  function classifyIntent(question) {
    var text = normalize(question).replace(/[’]/g, "'");
    var explicitNoSound = /no sound|can't hear|cannot hear|can not hear|nothing.*hear|没有声音|没声音|无声音|无声|听不到|没声/.test(text);
    var noSound = explicitNoSound || /not working|not work|does not work|doesn't work|is not working|isn't working|won't work|does not function/.test(text);

    if (/单边|只有.{0,4}一边|一边.{0,6}(没|没有).{0,2}声音|(?:only|just)\s+(?:the\s+)?(?:left|right|one)\s+(?:side|ear|earbud|earbuds|headphone|headphones).{0,24}(?:has|have|gets?|with)?\s*(?:sound|audio)|(?:sound|audio).{0,24}(?:only|just).{0,12}(?:left|right|one)\s+(?:side|ear|earbud|earbuds|headphone|headphones)|one[- ]sided?\s+(?:sound|audio)/.test(text)) return 'audio_quality';
    if (/optical|toslink|digital audio|光纤|数字音频/.test(text) && noSound) return 'optical_no_sound';
    if (/aux|3\.5|headphone jack|耳机孔|音频孔/.test(text) && noSound) return 'aux_no_sound';
    if (/disconnect|drop out|stutter|cutting out|cuts out|断开|掉线|卡顿|断断续续/.test(text)) return 'disconnect_stutter';
    if (/echo|delay|lip.?sync|out of sync|回声|延迟|不同步|对不上/.test(text)) return 'echo_issue';
    if (/reset|clear pairing|pairing history|恢复出厂|重置|清除配对/.test(text)) return 'factory_reset';
    if (/compatible|compatibility|will.*work|supported hearing aid|兼容|支持吗|能用吗|可以用吗/.test(text)) return 'device_compatibility';
    if (/hearing aid|助听器/.test(text) && /connect|pair|join|find|连接|配对|搜索/.test(text)) {
      return currentProduct && currentProduct.id === 'audikast-4ha' ? 'cannot_pair_hearing_aids' : 'device_compatibility';
    }
    if (/second|another|two|2|第二|两个|两副|双/.test(text) && /headphone|pair|耳机|配对/.test(text)) return 'second_headphones';
    if (explicitNoSound) return 'no_sound';
    if (/headphone|earbud|airpods?|air pods?|bose|sony|beats|jbl|jabra|耳机|耳塞/.test(text) && /connect|pair|find|连接|配对|搜索|连不上/.test(text)) return 'cannot_pair_headphones';
    if (/charg|battery|dock|充电|电池|电量/.test(text)) return 'charging_issue';
    if (/audio quality|distort|static|crackle|音质|失真|杂音|爆音/.test(text)) return 'audio_quality';
    if (/tv speaker|电视扬声器|电视喇叭/.test(text) && /together|same time|stay on|both|同时|一起/.test(text)) return 'tv_speakers_together';
    if (/flash|blink|indicator|light|闪烁|指示灯|亮灯/.test(text)) return 'flashing_indicator';
    if (/volume|too loud|too quiet|low sound|high sound|音量|太响|太大声|太小声/.test(text)) return 'volume_issue';
    if (noSound) return 'no_sound';
    return 'other';
  }

  function askAssistant(payload) {
    var fallback = {
      decision: 'SYSTEM_ERROR',
      answer: getUiText('load_error'),
      sourceReferences: [],
      knowledgeUsed: [],
      resolvedProduct: null,
      handoff: { required: false, attempted: false, completed: false, ticketOrHandoffId: null },
      missingField: '',
      mode: 'system_error',
      trace: {
        brand: 'avantree',
        experience_name: 'ask_avantree',
        canonical_decision: 'SYSTEM_ERROR',
        canonical_coverage: 'SYSTEM_ERROR',
        knowledge_required_domains: [],
        knowledge_used_domains: []
      }
    };
    if (!root.dataset.answerUrl) return Promise.resolve(fallback);
    return fetch(root.dataset.answerUrl, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        brand: 'avantree',
        experience_name: 'ask_avantree',
        session_id: sessionId,
        visitor_id: visitorId,
        question: payload.customerQuestion,
        canonical_turn_id: payload.questionEventId,
        question_event_id: payload.questionEventId,
        response_event_id: payload.responseEventId,
        answers: {},
        product_handle: root.dataset.productHandle || '',
        locale: currentLocale,
        page_url: window.location.href,
        page_title: root.dataset.pageContextTitle || document.title
      }),
      credentials: 'omit'
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (approved) {
      if (!approved) return fallback;
      var decision = approved.canonical_decision || 'SYSTEM_ERROR';
      if (!/^(ANSWER|ASK_CLARIFYING|GAP|CONFLICT|SYSTEM_ERROR|HANDOFF_REQUIRED)$/.test(decision || '')) return fallback;
      if (!approved.canonical_trace || typeof approved.canonical_trace !== 'object') return fallback;
      var evidence = Array.isArray(approved.knowledge_evidence) ? approved.knowledge_evidence : [];
      var sourceReferences = [];
      evidence.forEach(function (item) {
        if (!item || item.usedInFinalAnswer !== true || !item.sourceUrl) return;
        if (sourceReferences.some(function (source) { return source.url === item.sourceUrl; })) return;
        sourceReferences.push({ url: item.sourceUrl, label: sourceLabelForUrl(item.sourceUrl) });
      });
      var canonicalTrace = approved.canonical_trace;
      return {
        decision: decision,
        answer: approved.answer || fallback.answer,
        sourceReferences: sourceReferences.slice(0, 3),
        knowledgeUsed: approved.knowledge_used_domains || [],
        resolvedProduct: approved.canonical_product || null,
        handoff: approved.canonical_handoff || canonicalTrace.handoff || fallback.handoff,
        missingField: approved.missing_field || '',
        mode: (approved.knowledge_used_domains || []).join('+') || 'no_knowledge_required',
        trace: canonicalTrace
      };
    }).catch(function () { return fallback; });
  }

  function setProduct(product, preferProductLabel) {
    currentProduct = product;
    if (preferProductLabel) selectedProductOverridesPageContext = true;
    productName.textContent = !selectedProductOverridesPageContext && root.dataset.pageContextTitle
      ? root.dataset.pageContextTitle
      : product.title;
  }

  function renderProductOptions() {
    productSelect.textContent = '';
    var products = [data.general].concat(data.products || []).filter(Boolean);
    if (currentProduct && !products.some(function (product) { return productMatches(product, currentProduct.handle); })) {
      products.unshift(currentProduct);
    }
    products.forEach(function (product) {
      var localizedProduct = getProductContext(product.handle);
      var option = document.createElement('option');
      option.value = product.handle;
      option.textContent = localizedProduct.title;
      productSelect.appendChild(option);
    });
    productSelect.value = currentProduct.handle;
  }

  function setConversationActive(active) {
    root.dataset.conversationActive = active ? 'true' : 'false';
  }

  function clearConversation() {
    currentIntent = null;
    currentStepId = null;
    stepHistory = [];
    conversationLog = [];
    conversationState = null;
    handledResponseEventIds = {};
    stepsTaken = [];
    knowledgeFallbackHistory = {};
    awaitingProductModel = false;
    pendingProductQuestion = '';
    messages.textContent = '';
    messages.hidden = true;
    setConversationActive(false);
    updateBackButton();
  }

  function restartAssistant() {
    speech.stop();
    renewSessionId();
    selectedProductOverridesPageContext = false;
    if (data) setProduct(getProductContext(root.dataset.productHandle));
    clearConversation();
    productPicker.hidden = true;
    input.value = '';
    send.disabled = true;
    resizeInput();
    track('ask_avantree_restarted');
    input.focus();
  }

  function updateBackButton() {
    if (!backButton) return;
    backButton.hidden = stepHistory.length === 0;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
  }

  function startFloatingDrag(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (event.pointerType !== 'mouse' && event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    var rect = floatingButton.getBoundingClientRect();
    floatingDrag.active = true;
    floatingDrag.moved = false;
    floatingDrag.pointerId = event.pointerId;
    floatingDrag.startX = event.clientX;
    floatingDrag.startY = event.clientY;
    floatingDrag.left = rect.left;
    floatingDrag.top = rect.top;
    floatingDrag.width = rect.width;
    floatingDrag.height = rect.height;
    if (floatingButton.setPointerCapture) floatingButton.setPointerCapture(event.pointerId);
    floatingButton.dataset.dragging = 'true';
  }

  function moveFloatingButton(event) {
    if (!floatingDrag.active || event.pointerId !== floatingDrag.pointerId) return;
    var deltaX = event.clientX - floatingDrag.startX;
    var deltaY = event.clientY - floatingDrag.startY;
    if (!floatingDrag.moved && Math.hypot(deltaX, deltaY) < 5) return;
    floatingDrag.moved = true;
    event.preventDefault();
    var gap = 8;
    var left = clamp(floatingDrag.left + deltaX, gap, window.innerWidth - floatingDrag.width - gap);
    var top = clamp(floatingDrag.top + deltaY, gap, window.innerHeight - floatingDrag.height - gap);
    floatingButton.style.left = left + 'px';
    floatingButton.style.top = top + 'px';
    floatingButton.style.right = 'auto';
    floatingButton.style.bottom = 'auto';
    floatingButton.style.transform = 'none';
    floatingButton.dataset.dragged = 'true';
  }

  function finishFloatingDrag(event) {
    if (!floatingDrag.active || event.pointerId !== floatingDrag.pointerId) return;
    if (event.type === 'pointerup' && floatingDrag.moved) suppressFloatingClick = true;
    if (floatingButton.hasPointerCapture && floatingButton.hasPointerCapture(event.pointerId)) floatingButton.releasePointerCapture(event.pointerId);
    floatingDrag.active = false;
    floatingDrag.pointerId = null;
    delete floatingButton.dataset.dragging;
  }

  function keepFloatingButtonInView() {
    if (floatingButton.dataset.dragged !== 'true') return;
    var rect = floatingButton.getBoundingClientRect();
    var gap = 8;
    floatingButton.style.left = clamp(rect.left, gap, window.innerWidth - rect.width - gap) + 'px';
    floatingButton.style.top = clamp(rect.top, gap, window.innerHeight - rect.height - gap) + 'px';
  }

  function openDrawer(intent) {
    lastFocused = document.activeElement;
    root.dataset.open = 'true';
    drawer.focus();
    restoreCanonicalHandoff();
    track('ask_avantree_opened', { entry_point: intent ? 'product_support' : 'floating_or_general' });
  }

  function closeDrawer() {
    root.dataset.open = 'false';
    speech.stop();
    sendPortalEvent('closed');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function appendAnswerText(item, text) {
    // Render only HTTP(S) links; all model-provided text stays out of innerHTML.
    var content = String(text || '');
    var links = /\[([^\]\n]+)\]\((https?:\/\/[^\s<>"`]+)\)|https?:\/\/[^\s<>"`]+/gi;
    var cursor = 0;
    var match;
    while ((match = links.exec(content))) {
      var href = match[2] || match[0];
      if (!match[2]) {
        href = href.replace(/[.,!?;:，。！？；：]+$/, '');
        // Exclude surrounding punctuation but retain balanced URL parentheses.
        while (/[)\]}]$/.test(href)) {
          var close = href.slice(-1);
          var open = { ')': '(', ']': '[', '}': '{' }[close];
          if (href.split(close).length <= href.split(open).length) break;
          href = href.slice(0, -1);
        }
      }
      var valid = false;
      try {
        var url = new URL(href);
        valid = (url.protocol === 'https:' || url.protocol === 'http:') && !url.username && !url.password;
      } catch (error) {}
      if (!valid) continue;
      item.appendChild(document.createTextNode(content.slice(cursor, match.index)));
      var link = document.createElement('a');
      link.href = href;
      link.textContent = match[1] || (/^https:\/\/(?:www\.)?avantree\.com\/pages\/shipping-details(?:[/?#]|$)/i.test(href) ? sourceLabelForUrl(href) : href);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      item.appendChild(link);
      cursor = match.index + (match[2] ? match[0].length : href.length);
    }
    item.appendChild(document.createTextNode(content.slice(cursor)));
  }

  function createMessage(type, text, portalExtra, options) {
    setConversationActive(true);
    var row = document.createElement('div');
    row.className = 'ask-avantree__message-row ask-avantree__message-row--' + type;
    if (type === 'assistant') {
      var avatarTemplate = root.querySelector('[data-ask-avatar-template]');
      if (avatarTemplate && avatarTemplate.content) row.appendChild(avatarTemplate.content.cloneNode(true));
    }
    var body = document.createElement('div');
    body.className = 'ask-avantree__message-body';
    var item = document.createElement('div');
    item.className = 'ask-avantree__message ask-avantree__message--' + type;
    var paragraph = document.createElement('p');
    var displayText = type === 'assistant' ? formatProductText(text).replace(/\uE200[^]*?\uE201/g, '').trim() : text;
    if (type === 'assistant') appendAnswerText(paragraph, displayText);
    else paragraph.textContent = displayText;
    item.appendChild(paragraph);
    body.appendChild(item);
    var meta = document.createElement('div');
    meta.className = 'ask-avantree__message-meta';
    var now = new Date();
    var time = document.createElement('time');
    time.dateTime = now.toISOString();
    try {
      time.textContent = new Intl.DateTimeFormat(currentLocale, { hour: 'numeric', minute: '2-digit' }).format(now);
    } catch (error) {
      time.textContent = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    }
    meta.appendChild(time);
    if (type === 'customer') {
      var sent = document.createElement('span');
      sent.className = 'ask-avantree__message-sent';
      sent.setAttribute('aria-hidden', 'true');
      sent.textContent = '✓✓';
      meta.appendChild(sent);
    }
    body.appendChild(meta);
    row.appendChild(body);
    messages.appendChild(row);
    conversationLog.push({ role: type, text: displayText, eventId: options && options.eventId ? options.eventId : null });
    // The canonical API persists customer and assistant messages exactly once.
    // The frontend keeps this log only for the temporary on-screen transcript.
    return item;
  }

  function formatProductText(value) {
    return String(value || '').replace(/\{\{\s*product\s*\}\}/g, currentProduct ? currentProduct.title : 'this product');
  }

  function addSource(container, sourceKey) {
    if (!sourceKey || !currentProduct.sources || !currentProduct.sources[sourceKey]) return;
    var source = currentProduct.sources[sourceKey];
    var link = document.createElement('a');
    link.className = 'ask-avantree__source';
    link.href = source.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = root.dataset.sourceText + ': ' + formatProductText(source.label) + ' ↗';
    container.appendChild(link);
  }

  function sourceLabelForUrl(url) {
    var chinese = /^zh(?:-|$)/i.test(currentLocale);
    if (/^https:\/\/(?:www\.)?avantree\.com\/pages\/shipping-details(?:[/?#]|$)/i.test(url)) return chinese ? '配送说明' : 'Shipping details';
    if (/iug\.avantree\.com/i.test(url)) return chinese ? '用户指南' : 'User guide';
    if (/support\.avantree\.com/i.test(url)) return chinese ? 'Avantree 帮助中心' : 'Avantree Support';
    return chinese ? '产品页' : 'Product page';
  }

  function addSourceReference(container, source) {
    if (!source || !source.url) return;
    var link = document.createElement('a');
    link.className = 'ask-avantree__source';
    link.href = source.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = root.dataset.sourceText + ': ' + source.label + ' ↗';
    container.appendChild(link);
  }

  function scrollToLatest() {
    window.requestAnimationFrame(function () {
      conversation.scrollTop = conversation.scrollHeight;
    });
  }

  function startIntent(intent, preserveConversation) {
    var flow = getTroubleshootingFlow(currentProduct.handle, intent);
    if (!flow && currentProduct.intents && currentProduct.intents.other) {
      intent = 'other';
      flow = getTroubleshootingFlow(currentProduct.handle, intent);
    }
    if (!flow) {
      showEscalation();
      return;
    }

    currentIntent = intent;
    currentStepId = null;
    stepHistory = [];
    if (!preserveConversation) {
      conversationLog = [];
      stepsTaken = [];
      knowledgeFallbackHistory = {};
      messages.textContent = '';
    }
    messages.hidden = false;
    track('troubleshooting_started');
    showStep(flow.startStep, false);
  }

  function showStep(stepId, rememberCurrent) {
    var flow = getTroubleshootingFlow(currentProduct.handle, currentIntent);
    var step = flow && flow.steps ? flow.steps[stepId] : null;
    if (!step) {
      showEscalation();
      return;
    }

    if (rememberCurrent && currentStepId) stepHistory.push(currentStepId);
    currentStepId = stepId;
    stepsTaken.push({ intent: currentIntent, step: stepId });
    updateBackButton();

    var item = createMessage('assistant', step.message);
    addSource(item, step.source);

    if (step.requestProduct) {
      awaitingProductModel = true;
      productPicker.hidden = true;
      track('ask_avantree_product_requested', { step_id: stepId });
      input.focus();
      scrollToLatest();
      return;
    }

    var actions = document.createElement('div');
    actions.className = 'ask-avantree__step-actions';
    step.options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = option.label;
      button.addEventListener('click', function () {
        actions.querySelectorAll('button').forEach(function (candidate) { candidate.disabled = true; });
        createMessage('customer', option.label);
        track('troubleshooting_step', {
          step_id: stepId,
          customer_response: option.value || option.label
        });

        if (option.productHandle) {
          var selected = getProductContext(option.productHandle);
          if (!selected) return;
          setProduct(selected, true);
          renderLanguageOptions();
          renderProductOptions();
          clearConversation();
        } else if (option.resolved) {
          showResolution(option.resolution || flow.label);
        } else if (option.unresolved) {
          continueFromKnowledge(stepId);
        } else if (option.nextIntent) {
          startIntent(option.nextIntent, true);
        } else if (option.next) {
          showStep(option.next, true);
        } else {
          showEscalation();
        }
      });
      actions.appendChild(button);
    });
    item.appendChild(actions);
    track('troubleshooting_step', { step_id: stepId, state: 'shown' });
    scrollToLatest();
  }

  function continueFromKnowledge(stepId) {
    track('troubleshooting_unresolved', { step_id: stepId });
    showEscalation();
  }

  function showKnowledgeFallback() {
    var fallbackGroups = currentProduct && currentProduct.knowledgeFallbacks;
    var fallbacks = fallbackGroups && fallbackGroups[currentIntent];
    if (!Array.isArray(fallbacks)) return false;

    var fallback = fallbacks.find(function (candidate) {
      return !knowledgeFallbackHistory[currentIntent + ':' + candidate.id];
    });
    if (!fallback) return false;

    var fallbackKey = currentIntent + ':' + fallback.id;
    knowledgeFallbackHistory[fallbackKey] = true;
    stepsTaken.push({ intent: currentIntent, step: 'knowledge:' + fallback.id });

    var item = createMessage('assistant', fallback.message);
    addSource(item, fallback.source);

    var actions = document.createElement('div');
    actions.className = 'ask-avantree__step-actions';
    fallback.options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = option.label;
      button.addEventListener('click', function () {
        actions.querySelectorAll('button').forEach(function (candidate) { candidate.disabled = true; });
        createMessage('customer', option.label);
        track('troubleshooting_step', {
          step_id: 'knowledge:' + fallback.id,
          customer_response: option.value || option.label,
          knowledge_source: fallback.source
        });

        if (option.resolved) {
          showResolution(option.resolution || fallback.label || currentIntent);
        } else if (option.nextIntent) {
          startIntent(option.nextIntent, true);
        } else if (option.next) {
          showStep(option.next, true);
        } else {
          continueFromKnowledge('knowledge:' + fallback.id);
        }
      });
      actions.appendChild(button);
    });
    item.appendChild(actions);
    track('knowledge_fallback_shown', {
      step_id: 'knowledge:' + fallback.id,
      knowledge_source: fallback.source
    });
    scrollToLatest();
    return true;
  }

  function showResolution(resolution) {
    var panel = document.createElement('div');
    panel.className = 'ask-avantree__resolution';

    var title = document.createElement('strong');
    title.textContent = '✓ ' + root.dataset.resolvedTitle;
    panel.appendChild(title);

    var copy = document.createElement('p');
    copy.textContent = root.dataset.resolvedCopy;
    panel.appendChild(copy);

    var question = document.createElement('p');
    question.textContent = root.dataset.helpfulQuestion;
    panel.appendChild(question);

    var feedback = document.createElement('div');
    feedback.className = 'ask-avantree__feedback';
    [['👍', 'helpful_yes'], ['👎', 'helpful_no']].forEach(function (item) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = item[0];
      button.setAttribute('aria-label', getUiText(item[1]));
      button.addEventListener('click', function () {
        track(item[1], { resolution: resolution });
        feedback.querySelectorAll('button').forEach(function (candidate) { candidate.disabled = true; });
        if (item[1] === 'helpful_no') showFollowUpForm();
      });
      feedback.appendChild(button);
    });
    panel.appendChild(feedback);
    messages.appendChild(panel);
    track('troubleshooting_resolved', { resolved: true, resolution: resolution });
    scrollToLatest();
  }

  function showEscalation() {
    createMessage('assistant', getUiText('generic_followup'));
    scrollToLatest();
  }

  function showFollowUpForm(response) {
    if (!response || response.decision !== 'HANDOFF_REQUIRED' || !response.handoff || response.handoff.required !== true) return;
    if (messages.querySelector('[data-ask-followup]') || root.dataset.handoffStarting === 'true' || !root.dataset.followupUrl) return;
    root.dataset.handoffStarting = 'true';
    fetch(root.dataset.followupUrl, {
      method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'omit',
      body: JSON.stringify({ action: 'start', session_id: sessionId, canonical_trace_id: response.trace.traceId, locale: currentLocale })
    }).then(function (request) { if (!request.ok) throw new Error('handoff_start_failed'); return request.json(); })
      .then(function (result) {
        if (result.handoff && result.handoff.completed === true && result.handoff.supportCaseId) return renderCompletedHandoff(result.handoff, result.customerMessage);
        if (result.emailRequired !== true) {
          if (result.customerMessage) createMessage('assistant', result.customerMessage);
          return false;
        }
        messages.appendChild(buildFollowUpForm(response, result));
        scrollToLatest();
        return true;
      })
      .catch(function () { createMessage('assistant', getUiText('escalation_email_failure')); })
      .finally(function () { root.dataset.handoffStarting = 'false'; });
  }

  function buildFollowUpForm(response, startResult) {
    var followUp = document.createElement('form');
    followUp.className = 'ask-avantree__followup';
    followUp.dataset.askFollowup = 'true';
    var title = document.createElement('strong'); title.textContent = getUiText('escalation_email_title'); followUp.appendChild(title);
    var copy = document.createElement('p'); copy.textContent = startResult.customerMessage || getUiText('escalation_email_copy'); followUp.appendChild(copy);
    var email = document.createElement('input'); email.type = 'email'; email.required = true; email.autocomplete = 'email'; email.placeholder = getUiText('followup_email'); email.setAttribute('aria-label', getUiText('followup_email')); followUp.appendChild(email);
    var consentLabel = document.createElement('label'); consentLabel.className = 'ask-avantree__followup-consent';
    var consent = document.createElement('input'); consent.type = 'checkbox'; consent.required = true; consent.className = 'ask-avantree__consent-checkbox'; consentLabel.appendChild(consent);
    var consentBox = document.createElement('span'); consentBox.className = 'ask-avantree__consent-box'; consentBox.setAttribute('aria-hidden', 'true'); consentLabel.appendChild(consentBox);
    consentLabel.appendChild(document.createTextNode(getUiText('followup_consent'))); followUp.appendChild(consentLabel);
    var submit = document.createElement('button'); submit.type = 'submit'; submit.textContent = getUiText('escalation_email_submit'); followUp.appendChild(submit);
    var decline = document.createElement('button'); decline.type = 'button'; decline.textContent = getUiText('escalation_email_decline'); followUp.appendChild(decline);
    var status = document.createElement('p'); status.className = 'ask-avantree__followup-status'; status.setAttribute('aria-live', 'polite'); followUp.appendChild(status);
    followUp.addEventListener('submit', function (event) {
      event.preventDefault(); if (!followUp.reportValidity() || !root.dataset.followupUrl) return;
      submit.disabled = true; decline.disabled = true; status.textContent = getUiText('escalation_email_sending');
      fetch(root.dataset.followupUrl, { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'omit', body: JSON.stringify({ action: 'submit_email', session_id: sessionId, canonical_trace_id: response.trace.traceId, email: email.value, consent: consent.checked, locale: currentLocale, brand: 'avantree', experience_name: 'ask_avantree' }) })
        .then(function (response) { if (!response.ok) throw new Error('followup_failed'); return response.json(); })
        .then(function (result) {
          if (result.emailValidation === 'invalid') { submit.disabled = false; decline.disabled = false; status.textContent = result.customerMessage || getUiText('followup_error'); return; }
          if (!result.handoff || result.handoff.completed !== true || !result.handoff.supportCaseId) { followUp.hidden = true; createMessage('assistant', result.customerMessage || getUiText('escalation_email_failure')); return; }
          email.disabled = true; consent.disabled = true; followUp.hidden = true;
          renderCompletedHandoff(result.handoff, result.customerMessage);
          track('ask_avantree_followup_requested', { handoff_method: result.handoff.method || '', handoff_id: result.handoff.supportCaseId });
        })
        .catch(function () { submit.disabled = false; decline.disabled = false; status.textContent = getUiText('escalation_email_failure'); });
    });
    decline.addEventListener('click', function () {
      submit.disabled = true; decline.disabled = true;
      fetch(root.dataset.followupUrl, { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'omit', body: JSON.stringify({ action: 'decline_email', session_id: sessionId, canonical_trace_id: response.trace.traceId, locale: currentLocale }) })
        .then(function (request) { if (!request.ok) throw new Error('handoff_decline_failed'); return request.json(); })
        .then(function (result) { followUp.hidden = true; createMessage('assistant', result.customerMessage || 'You can contact support@avantrae.com directly.'); })
        .catch(function () { submit.disabled = false; decline.disabled = false; status.textContent = getUiText('escalation_email_failure'); });
    });
    return followUp;
  }

  function renderCompletedHandoff(handoff, customerMessage) {
    var supportCaseId = handoff && (handoff.supportCaseId || handoff.ticketId || handoff.handoffId);
    if (!handoff || handoff.completed !== true || !supportCaseId || messages.querySelector('[data-ask-handoff-completed]')) return false;
    var item = createMessage('assistant', (customerMessage || getUiText('handoff_completed')) + ' ' + supportCaseId);
    item.dataset.askHandoffCompleted = 'true';
    messages.hidden = false;
    track('support_escalated', { handoff_method: handoff.method || '', handoff_id: supportCaseId });
    scrollToLatest();
    return true;
  }

  function restoreCanonicalHandoff() {
    if (!root.dataset.followupUrl || messages.querySelector('[data-ask-handoff-completed]')) return;
    fetch(root.dataset.followupUrl, {
      method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'omit',
      body: JSON.stringify({ action: 'status', session_id: sessionId })
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (result) {
      if (result && result.handoff) renderCompletedHandoff(result.handoff);
    }).catch(function () {});
  }

  function goBack() {
    if (!stepHistory.length || !currentIntent) return;
    var previous = stepHistory.pop();
    messages.textContent = '';
    conversationLog = [];
    currentStepId = null;
    showStep(previous, false);
  }

  function createSpeechAdapter() {
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    var recognition = Recognition ? new Recognition() : null;
    var listening = false;
    var locale = translations && translations.locales ? translations.locales[currentLocale] : null;
    root.dataset.speechLocale = locale && locale.speechLocale ? locale.speechLocale : currentLocale;

    if (!recognition) {
      mic.disabled = true;
      mic.title = root.dataset.voiceUnavailableText;
      voiceStatus.textContent = root.dataset.voiceUnavailableText;
      return { supported: false, start: function () {}, stop: function () {}, setLanguage: function () {} };
    }

    function updateLanguage() {
      var selected = translations && translations.locales ? translations.locales[currentLocale] : null;
      recognition.lang = selected && selected.speechLocale ? selected.speechLocale : currentLocale;
      root.dataset.speechLocale = recognition.lang;
    }

    updateLanguage();
    recognition.interimResults = true;
    recognition.continuous = false;

    recognition.onstart = function () {
      listening = true;
      mic.dataset.listening = 'true';
      voiceStatus.textContent = root.dataset.listeningText;
    };

    recognition.onresult = function (event) {
      var transcript = '';
      for (var index = event.resultIndex; index < event.results.length; index += 1) {
        transcript += event.results[index][0].transcript;
      }
      input.value = transcript.trim();
      send.disabled = !input.value;
      resizeInput();
    };

    recognition.onerror = function () {
      voiceStatus.textContent = root.dataset.voiceErrorText;
    };

    recognition.onend = function () {
      listening = false;
      mic.dataset.listening = 'false';
      if (input.value) {
        voiceStatus.textContent = '';
        input.focus();
      }
    };

    return {
      supported: true,
      start: function () {
        if (listening) {
          recognition.stop();
          return;
        }
        track('ask_avantree_voice_used');
        recognition.start();
      },
      stop: function () {
        if (listening) recognition.stop();
      },
      setLanguage: updateLanguage
    };
  }

  function changeLocale(locale, shouldTrack) {
    currentLocale = normalizeLocale(locale);
    try {
      window.sessionStorage.setItem('askAvantreeLocale', currentLocale);
    } catch (error) {}

    applyUiTranslations();
    renderLanguageOptions();
    if (data) {
      var activeHandle = currentProduct ? currentProduct.handle : root.dataset.productHandle;
      setProduct(getProductContext(activeHandle));
      renderProductOptions();
      clearConversation();
    }
    if (speech.setLanguage) speech.setLanguage();
    voiceStatus.textContent = '';
    if (shouldTrack) track('ask_avantree_language_changed', { selected_locale: currentLocale });
  }

  function fetchJson(url, required) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('JSON request failed: ' + response.status);
      return response.json();
    }).catch(function (error) {
      if (required) throw error;
      return null;
    });
  }

  function resizeInput() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 116) + 'px';
  }

  function showCanonicalResponse(response, responseEventId) {
    currentIntent = response.trace && response.trace.intent ? response.trace.intent.intent : 'other';
    currentStepId = null;
    stepsTaken.push({
      intent: currentIntent,
      step: 'canonical-decision:' + response.decision
    });
    messages.hidden = false;
    root.dataset.lastCanonicalDecision = response.decision;
    root.dataset.lastKnowledgeMode = response.mode;
    root.dataset.lastKnowledgeSources = response.sourceReferences.map(function (source) { return source.label; }).join(' | ');
    root.dataset.lastKnowledgeUsed = response.knowledgeUsed.join(' | ');
    root.dataset.lastCanonicalTraceId = response.trace.traceId || '';
    var pendingHandoffForm = messages.querySelector('[data-ask-followup]');
    if (response.decision !== 'HANDOFF_REQUIRED' && pendingHandoffForm) pendingHandoffForm.remove();

    if (root.dataset.pageContextTitle && !selectedProductOverridesPageContext) {
      productName.textContent = root.dataset.pageContextTitle;
    } else if (response.resolvedProduct && response.resolvedProduct.productName) {
      productName.textContent = response.resolvedProduct.productName;
    } else if (!response.resolvedProduct || !response.resolvedProduct.productHandle) {
      var generalProduct = data && data.general ? getProductContext(data.general.handle) : null;
      if (generalProduct) setProduct(generalProduct);
      else productName.textContent = 'Avantree';
    }

    var item = createMessage('assistant', response.answer, {
      sources_used: response.sourceReferences.map(function (source) { return source.url || source.label; }).filter(Boolean),
      guidance_trace: response.trace
    }, { eventId: responseEventId });
    response.sourceReferences.forEach(function (source) { addSourceReference(item, source); });

    if (response.decision === 'HANDOFF_REQUIRED') {
      var supportCaseId = response.handoff && (response.handoff.supportCaseId || response.handoff.ticketId || response.handoff.handoffId);
      if (response.handoff && response.handoff.completed === true && supportCaseId) renderCompletedHandoff(response.handoff);
      else if (root.dataset.askHandoffAdapter !== 'true') showFollowUpForm(response);
    }

    if (response.resolvedProduct && response.resolvedProduct.productHandle
      && normalize(response.resolvedProduct.productHandle) !== normalize(root.dataset.productHandle)) {
      var productLink = document.createElement('a');
      productLink.className = 'ask-avantree__product-navigation';
      productLink.href = '/products/' + encodeURIComponent(response.resolvedProduct.productHandle);
      productLink.textContent = (response.resolvedProduct.productName || response.resolvedProduct.productHandle) + ' →';
      item.appendChild(productLink);
    }

    if (response.decision === 'ASK_CLARIFYING') {
      track('ask_avantree_clarifying_question_shown');
    } else if (response.decision === 'ANSWER') {
      track('knowledge_answer_shown', { knowledge_source: response.knowledgeUsed.join(' | ') });
    }
    scrollToLatest();
  }

  function searchStoreProducts(query) {
    var endpoint = root.dataset.productSearchUrl || '/search/suggest';
    if (!/\.json(?:\?|$)/.test(endpoint)) endpoint = endpoint.replace(/\/$/, '') + '.json';
    var url = new URL(endpoint, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '5');
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Product search failed: ' + response.status);
      return response.json();
    }).then(function (payload) {
      var results = payload && payload.resources && payload.resources.results;
      return results && Array.isArray(results.products) ? results.products : [];
    });
  }

  function questionMentionsStoreProduct(question, product) {
    var normalizedQuestion = ' ' + normalizeProductPhrase(question) + ' ';
    var titleLead = normalizeProductPhrase(String(product.title || '').split('|')[0]);
    if (titleLead.length >= 3 && normalizedQuestion.indexOf(' ' + titleLead + ' ') !== -1) return true;

    var modelTokens = (String(product.title || '') + ' ' + String(product.handle || ''))
      .match(/[a-z]{1,8}[- ]?\d{3,}[a-z0-9-]*/gi) || [];
    return modelTokens.some(function (token) {
      var normalizedToken = normalizeProductPhrase(token).replace(/\s+/g, '');
      return normalizeProductPhrase(question).replace(/\s+/g, '').indexOf(normalizedToken) !== -1;
    });
  }

  function readProductHandoff() {
    try {
      var raw = window.sessionStorage.getItem(PRODUCT_HANDOFF_KEY);
      if (!raw) return null;
      var handoff = JSON.parse(raw);
      if (!handoff.createdAt || Date.now() - handoff.createdAt > PRODUCT_HANDOFF_TTL) {
        window.sessionStorage.removeItem(PRODUCT_HANDOFF_KEY);
        return null;
      }
      return handoff;
    } catch (error) {
      return null;
    }
  }

  function clearProductHandoff() {
    try { window.sessionStorage.removeItem(PRODUCT_HANDOFF_KEY); } catch (error) {}
  }

  function writeProductHandoff(product, requestedModel, originalQuestion, turnEventIds) {
    var productUrl = new URL(product.url || product.pageUrl, window.location.origin);
    productUrl.search = '';
    productUrl.searchParams.set('ask_avantree_continue', '1');
    var handoff = {
      targetHandle: product.handle,
      targetTitle: product.title,
      targetUrl: productUrl.toString(),
      requestedModel: requestedModel,
      originalQuestion: originalQuestion || '',
      turnEventIds: turnEventIds || null,
      locale: currentLocale,
      conversation: conversationLog.slice(),
      conversationState: conversationState,
      handledResponseEventIds: Object.keys(handledResponseEventIds),
      createdAt: Date.now()
    };
    try { window.sessionStorage.setItem(PRODUCT_HANDOFF_KEY, JSON.stringify(handoff)); } catch (error) {}
    return handoff;
  }

  function goToProduct(product, requestedModel, originalQuestion, turnEventIds) {
    var productContext = {
      title: String(product.title || '').split('|')[0].trim() || product.title,
      handle: product.handle,
      url: product.url || product.pageUrl
    };
    var handoff = writeProductHandoff(productContext, requestedModel, originalQuestion, turnEventIds);
    track('ask_avantree_product_found', { requested_model_length: requestedModel.length });
    window.location.assign(handoff.targetUrl);
  }

  function requestProductModel(originalQuestion, turnEventIds) {
    awaitingProductModel = true;
    if (originalQuestion) pendingProductQuestion = originalQuestion;
    if (turnEventIds) pendingProductTurnEventIds = turnEventIds;
    productPicker.hidden = true;
    messages.hidden = false;
    createMessage('assistant', getUiText('ask_product_model'));
    track('ask_avantree_product_requested');
    input.focus();
    scrollToLatest();
  }

  function handleProductModelAnswer(model) {
    var modelEventIds = { question: eventId(), response: eventId() };
    createMessage('customer', model, null, { eventId: modelEventIds.question });
    track('ask_avantree_product_search', { requested_model_length: model.length });
    voiceStatus.textContent = getUiText('searching_products');
    searchStoreProducts(model).then(function (products) {
      voiceStatus.textContent = '';
      if (!products.length) {
        createMessage('assistant', getUiText('product_not_found'));
        input.focus();
        scrollToLatest();
        return;
      }
      awaitingProductModel = false;
      goToProduct(products[0], model, pendingProductQuestion || model, modelEventIds);
    }).catch(function () {
      voiceStatus.textContent = '';
      createMessage('assistant', getUiText('product_search_error'));
      input.focus();
      scrollToLatest();
    });
  }

  function answerQuestion(question, turnEventIds) {
    var messageEventIds = turnEventIds || { question: eventId(), response: eventId() };
    if (handledResponseEventIds[messageEventIds.response]) return;
    handledResponseEventIds[messageEventIds.response] = true;
    requestInFlight = true;
    input.disabled = true;
    send.disabled = true;
    askAssistant({
      customerQuestion: question,
      questionEventId: messageEventIds.question,
      responseEventId: messageEventIds.response
    }).then(function (response) {
      showCanonicalResponse(response, messageEventIds.response);
    }).finally(function () {
      requestInFlight = false;
      input.disabled = false;
      send.disabled = !input.value.trim();
      input.focus();
    });
  }

  function restoreProductHandoff(handoff) {
    if (!handoff || normalize(handoff.targetHandle) !== normalize(root.dataset.productHandle)) return false;
    messages.textContent = '';
    conversationLog = [];
    conversationState = handoff.conversationState || null;
    handledResponseEventIds = {};
    (handoff.handledResponseEventIds || []).forEach(function (id) { handledResponseEventIds[id] = true; });
    (handoff.conversation || []).forEach(function (message) {
      createMessage(message.role === 'customer' ? 'customer' : 'assistant', message.text, null, { persist: false, eventId: message.eventId || null });
    });
    messages.hidden = false;
    openDrawer('');
    clearProductHandoff();
    track('ask_avantree_product_handoff_completed');
    if (handoff.originalQuestion) answerQuestion(handoff.originalQuestion, handoff.turnEventIds);
    else {
      createMessage('assistant', getUiText('product_confirmed'));
      input.focus();
      scrollToLatest();
    }
    return true;
  }

  function handleQuestion(question) {
    knowledgeFallbackHistory = {};
    var turnEventIds = { question: eventId(), response: eventId() };
    createMessage('customer', question, null, { eventId: turnEventIds.question });
    track('ask_avantree_question', { question_length: question.length });
    answerQuestion(question, turnEventIds);
  }

  function trapFocus(event) {
    if (root.dataset.open !== 'true' || event.key !== 'Tab') return;
    var focusable = drawer.querySelectorAll('button:not([disabled]):not([hidden]), a[href], textarea, select, [tabindex="0"]');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var speech = { supported: false, start: function () {}, stop: function () {}, setLanguage: function () {} };

  Promise.all([
    fetchJson(root.dataset.knowledgeUrl, true),
    fetchJson(root.dataset.translationsUrl, false)
  ])
    .then(function (payloads) {
      data = payloads[0];
      translations = payloads[1];
      var handoff = readProductHandoff();
      currentLocale = handoff && handoff.locale ? normalizeLocale(handoff.locale) : detectLocale();
      if (!localeSupportedByProduct(rawProductForHandle(root.dataset.productHandle), currentLocale)) currentLocale = 'en-US';
      applyUiTranslations();
      setProduct(getProductContext(root.dataset.productHandle));
      renderProductOptions();
      renderLanguageOptions();
      speech = createSpeechAdapter();
      clearProductHandoff();
      if (pendingCanonicalQuestion) {
        var queuedQuestion = pendingCanonicalQuestion;
        pendingCanonicalQuestion = '';
        handleQuestion(queuedQuestion);
      }
    })
    .catch(function () {
      productName.textContent = root.dataset.pageContextTitle || root.dataset.productTitle || root.dataset.productPending;
      mic.hidden = true;
    });

  document.querySelectorAll('[data-ask-open]').forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      if (opener === floatingButton && suppressFloatingClick) {
        suppressFloatingClick = false;
        return;
      }
      if (opener === floatingButton && root.dataset.open === 'true') {
        closeDrawer();
        return;
      }
      var openerQuestion = String(opener.dataset.askQuestion || '').trim();
      openDrawer(openerQuestion);
      if (!openerQuestion || requestInFlight) return;
      if (!data || !currentProduct) pendingCanonicalQuestion = openerQuestion;
      else handleQuestion(openerQuestion);
    });
  });

  if (floatingButton) {
    floatingButton.addEventListener('pointerdown', startFloatingDrag);
    floatingButton.addEventListener('pointermove', moveFloatingButton);
    floatingButton.addEventListener('pointerup', finishFloatingDrag);
    floatingButton.addEventListener('pointercancel', finishFloatingDrag);
    window.addEventListener('resize', keepFloatingButtonInView);
  }

  root.querySelectorAll('[data-ask-close]').forEach(function (closer) {
    closer.addEventListener('click', closeDrawer);
  });

  root.querySelector('[data-ask-change-product]').addEventListener('click', function () {
    input.placeholder = getUiText('ask_product_model');
    input.focus();
  });

  root.querySelector('[data-ask-restart]').addEventListener('click', restartAssistant);

  if (languageSelect) {
    languageSelect.addEventListener('change', function () {
      changeLocale(languageSelect.value, true);
    });
  }

  productSelect.addEventListener('change', function () {
    var rawProduct = rawProductForHandle(productSelect.value);
    if (!localeSupportedByProduct(rawProduct, currentLocale)) {
      currentLocale = 'en-US';
      applyUiTranslations();
    }
    var selected = getProductContext(productSelect.value);
    if (!selected) return;
    setProduct(selected, true);
    renderLanguageOptions();
    clearConversation();
    productPicker.hidden = true;
  });

  if (backButton) backButton.addEventListener('click', goBack);
  mic.addEventListener('click', function () { speech.start(); });

  input.addEventListener('input', function () {
    send.disabled = !input.value.trim();
    resizeInput();
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (input.value.trim()) form.requestSubmit();
    }
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var question = input.value.trim();
    if (!question || !currentProduct || requestInFlight) return;
    input.value = '';
    send.disabled = true;
    resizeInput();
    messages.hidden = false;
    handleQuestion(question);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.dataset.open === 'true') closeDrawer();
    trapFocus(event);
  });

  window.AskAvantree = {
    getProductContext: getProductContext,
    getTroubleshootingFlow: getTroubleshootingFlow,
    searchProductKnowledge: searchProductKnowledge,
    detectProductFromQuestion: detectProductFromQuestion,
    askAssistant: askAssistant,
    showCanonicalResponse: showCanonicalResponse,
    open: openDrawer,
    close: closeDrawer
  };
})();
